<div
  *ngIf="shop"
  (click)="selectShop()"
  class="shop"
  [ngClass]="{ active: (isActive$ | async), remove: (isRemove$ | async) }"
>
  <button (click)="removeShop()" class="btn btn-more btn-link" tabindex="-1">
    <cx-icon class="icon" [type]="iconType.TRASHBIN"></cx-icon>
  </button>

  <div *ngIf="isMyShop$ | async" class="shop-my-shop">
    <cx-icon [type]="iconType.STAR"></cx-icon>
    <span>Мой магазин</span>
  </div>

  <div class="shop-address">{{ shop.addressFormatted }}</div>

  <div class="shop-worktime">
    <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
  </div>

  <div class="shop-available">
    <ng-container *ngIf="shop.pickupDate; else pickupDateEmpty">
      <cx-icon [type]="iconType.EXCLAMATION_POINT"></cx-icon>
      <span>{{ ' ' }}Доступно {{ shop.pickupDate | uiTodayTomorrowDate: 'с d MMMM' }}</span>
    </ng-container>
    <ng-template #pickupDateEmpty>
      <span>{{ ' ' }}Дату самовывоза уточнит оператор</span>
    </ng-template>
  </div>
</div>
